import { inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '@anecdotes/configuration-data-access';
import { MobileTypes } from '../../models';
import { WindowHelperService } from '@anecdotes/utils';

@Injectable()
export class MobileAndNotSupportBrowserService {
  private readonly config = inject(APP_CONFIG);
  private readonly windowHelperService = inject(WindowHelperService);

  isMobile: MobileTypes;
  isBrowserSupported: boolean;
  browserNotSupportedLink: string;

  initialize(): void {
    this.checkMobileDevice();

    if (!this.isMobile.allTypes()) {
      this.detectSupportedBrowser();
    }
  }

  get isCurrentBrowserSupported(): boolean {
    if (this.isMobile.allTypes()) {
      return false;
    }

    return !!this.isBrowserSupported;
  }

  checkMobileDevice(): void {
    const win = this.windowHelperService.getWindow();
    this.isMobile = {
      Android: () => {
        return !!win.navigator.userAgent.match(/Android/i);
      },
      BlackBerry: () => {
        return !!win.navigator.userAgent.match(/BlackBerry/i);
      },
      iOS: () => {
        return !!win.navigator.userAgent.match(/iPhone|iPad|iPod/i);
      },
      Opera: () => {
        return !!win.navigator.userAgent.match(/Opera Mini/i);
      },
      Windows: () => {
        return !!win.navigator.userAgent.match(/IEMobile/i);
      },
      allTypes: () => {
        return (
          this.isMobile.Android() ||
          this.isMobile.BlackBerry() ||
          this.isMobile.iOS() ||
          this.isMobile.Opera() ||
          this.isMobile.Windows()
        );
      },
    };
  }

  detectSupportedBrowser(): void {
    const win = this.windowHelperService.getWindow();
    const agent = win.navigator.userAgent.toLowerCase();
  
    this.isBrowserSupported = this.config.supportedBrowsers.some((browser: string) => agent.match(browser));

    if (!this.isBrowserSupported) {
      this.browserNotSupportedLink = this.config.redirectUrls.browserNotSupported;
      this.setLocationHref(this.browserNotSupportedLink);
    }
  }

  private setLocationHref(link: string): void {
    const win = this.windowHelperService.getWindow();
    win.location.href = link;
  }
}
